import { useEffect, useState } from 'react'
const HookEnrollCourse = () => {
    const [Status, setStatus] = useState(false)
    const [Sucdeed, setSucdeed] = useState(false)
  

    return { Status, Sucdeed, setStatus, setSucdeed }
}

export default HookEnrollCourse